import { render, staticRenderFns } from "./hw-location.vue?vue&type=template&id=161cc7c9&scoped=true&"
import script from "./hw-location.vue?vue&type=script&lang=js&"
export * from "./hw-location.vue?vue&type=script&lang=js&"
import style0 from "./hw-location.vue?vue&type=style&index=0&id=161cc7c9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161cc7c9",
  null
  
)

export default component.exports